import { Modal } from "antd";
import moment from "moment";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import { getAuthorSummaryById, getUniverseSummaryById } from "./endpoint";
import { toast } from "react-toastify";
import pageReloadOptions from "./enums";

export default function WebtoonModal({
  openWebtoonModel,
  setOpenWebtoonModel,
  webtoonSummaryData,
  permissions,
  currentAuthorId,
  currentUniverseId,
  isPageReload,
  isLinkFunctionalityActive = false
}) {

  const navigate = useNavigate()

  const handleRedirectToViewAuthorPage = async (authorId) => {
    try {
      const res = await getAuthorSummaryById(authorId);
      let url = `/admin/author/view-author/${authorId}?redirect=1`

      if(isPageReload === pageReloadOptions.AUTHOR){
        setOpenWebtoonModel(false);
        localStorage.setItem('is_same_author_view_page',true);
        url = `/admin/author/view-author/${authorId}?redirect=1`
      }

      navigate(url, {
        state: { row: res?.data },
      });
    } catch (error) {
      toast.error(`${error.message}`);
    }
  }

  const handleRedirectToViewUniversePage = async (unvierseId) => {
    try {
      const res = await getUniverseSummaryById(unvierseId);
      let url = `/admin/universe/view-universe/${unvierseId}?redirect=1`

      if(isPageReload === pageReloadOptions.UNIVERSE){
        setOpenWebtoonModel(false);
        localStorage.setItem('is_same_universe_view_page',true);
        url = `/admin/universe/view-universe/${unvierseId}`
      }

      navigate(url, {
        state: { row: res?.data },
      });
    } catch (error) {
      toast.error(`${error.message}`);
    }
  }

  return (
    <Modal
      title="Webtoon Detail"
      centered
      open={openWebtoonModel}
      onOk={() => openWebtoonModel(false)}
      onCancel={() => setOpenWebtoonModel(false)}
      okButtonProps={{ className:"model-bg-color" }}
      cancelButtonProps={{ className:"model-border-color" }}  
    >
      <Card>
        <Row>
          <Col lg="12">
            <Card className="shadow m-4 detail_card">
              <CardBody className="custom-margin-top">
                <Row>
                  {webtoonSummaryData?.en_title ? (
                    <>
                      <Col lg="4"> EN Title</Col>
                      <Col lg="8">
                        <div className="text-dark h4">
                          {webtoonSummaryData.en_title}
                        </div>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>
                <Row className="mt-1">
                  {webtoonSummaryData?.universe_name ? (
                    <>
                      <Col lg="4">Universe Name</Col>
                      <Col lg="8">
                        
                        {!isLinkFunctionalityActive ? 
                            <span>{webtoonSummaryData?.universe_name}</span>
                           : 
                           currentUniverseId === webtoonSummaryData.universe_id ?
                            <span>
                                {webtoonSummaryData?.universe_name}
                            </span> 
                           : 
                            <span className="primary-text-color" style={{cursor: "pointer"}} onClick={() =>
                              handleRedirectToViewUniversePage(webtoonSummaryData.universe_id)
                            }>
                              {webtoonSummaryData?.universe_name}
                            </span>
                          }
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>
                <Row className="mt-1">
                  {webtoonSummaryData?.jp_title ? (
                    <>
                      <Col lg="4">JP Title</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.jp_title}
                        </span>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>

                <Row className="mt-1">
                  {webtoonSummaryData?.kr_title ? (
                    <>
                      <Col lg="4">KR Title</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.kr_title}
                        </span>
                      </Col>
                    </>
                  ) : (
                    ""
                  )}
                </Row>

                {webtoonSummaryData?.status_name ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">Status</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.status_name}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.no_of_volumes ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">No. of chpt</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.no_of_volumes}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.ongoing || !webtoonSummaryData?.ongoing && webtoonSummaryData?.ongoing !== null ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4">Ongoing</Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {webtoonSummaryData.ongoing === true ? "Yes" : "No"}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                {webtoonSummaryData?.type_name ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">Type</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.type_name}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.jp_platform ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">JP Platform</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.jp_platform}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.kr_platform ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">KR Platform</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData.kr_platform}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.fr_platform ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">FR Platform</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.fr_platform}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.us_platform ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">US Platform</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.us_platform}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.jp_platform_likes ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">JP Platform Likes</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.jp_platform_likes}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.kr_platform_likes ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">KR Platform Likes</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.kr_platform_likes}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.fr_platform_likes ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">FR Platform Likes</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.fr_platform_likes}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.us_platform_likes ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">US Platform Likes</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData?.us_platform_likes}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.jp_wikipedia_link ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">JP Wikipedia</Col>
                      <Col lg="8">
                        <div className="link primary-text-color text-wrap">
                          <a
                            href={webtoonSummaryData?.jp_wikipedia_link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {webtoonSummaryData?.jp_wikipedia_link?.length > 50
                              ? `${webtoonSummaryData?.jp_wikipedia_link.slice(
                                  0,
                                  40
                                )}...`
                              : webtoonSummaryData?.jp_wikipedia_link}
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.kr_wikipedia_link ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">KR Wikipedia</Col>
                      <Col lg="8">
                        <div className="link primary-text-color text-wrap">
                          <a
                            href={webtoonSummaryData?.kr_wikipedia_link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {webtoonSummaryData?.kr_wikipedia_link?.length > 50
                              ? `${webtoonSummaryData?.kr_wikipedia_link.slice(
                                  0,
                                  40
                                )}...`
                              : webtoonSummaryData?.kr_wikipedia_link}
                          </a>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {webtoonSummaryData?.jp_raw ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">JP Raw</Col>
                      <Col lg="8">
                      <span className="text-dark">
                          {webtoonSummaryData?.jp_raw}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}

                {permissions &&
                  permissions.map((permission) =>
                    permission === "view-webtoon-price" ? (
                      <>
                        {webtoonSummaryData?.low_sales ? (
                          <>
                            <Row className="mt-1">
                              <Col lg="4">Low Sales</Col>
                              <Col lg="8">
                                <span className="text-dark">
                                  {webtoonSummaryData?.low_sales}
                                </span>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          ""
                        )}

                        {webtoonSummaryData?.medium_sales ? (
                          <>
                            <Row className="mt-1">
                              <Col lg="4">Medium Sales</Col>
                              <Col lg="8">
                                <span className="text-dark">
                                  {webtoonSummaryData?.medium_sales}
                                </span>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          ""
                        )}

                        {webtoonSummaryData?.high_sales ? (
                          <>
                            <Row className="mt-1">
                              <Col lg="4">High Sales</Col>
                              <Col lg="8">
                                <span className="text-dark">
                                  {webtoonSummaryData?.high_sales}
                                </span>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          ""
                        )}

                        {webtoonSummaryData?.fr_consumer_price ? (
                          <>
                            <Row className="mt-1">
                              <Col lg="4">FR Consumer Price</Col>
                              <Col lg="8">
                                <span className="text-dark">
                                  {webtoonSummaryData?.fr_consumer_price}
                                </span>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          ""
                        )}
                      </>
                    ) : (
                      ""
                    )
                  )}

              {permissions &&
                      permissions.map((permission) =>
                        permission === "view-webtoon-product-pl" ? (
                          <>
                              {webtoonSummaryData?.product_pl ? (
                                <>
                                <Row className="mt-1">
                                  <Col lg="4">Product P&L</Col>
                                  <Col lg="8">
                                      <span className="link primary-text-color text-wrap">
                                          <a
                                            href={webtoonSummaryData?.product_pl}
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            {webtoonSummaryData?.product_pl?.length >
                                            50
                                              ? `${webtoonSummaryData?.product_pl.slice(
                                                  0,
                                                  40
                                                )}...`
                                              : webtoonSummaryData?.product_pl}
                                          </a>
                                      </span>
                                  </Col>
                                </Row>
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          ""
                        )
                )}

                {webtoonSummaryData?.created_at ? (
                  <>
                    <Row className="mt-1">
                      <Col lg="4">CreatedAt</Col>
                      <Col lg="8">
                        <span className="text-dark">
                          {webtoonSummaryData.created_at
                            ? moment(webtoonSummaryData.created_at).format(
                                "YYYY-MM-DD HH:mm:ss"
                              )
                            : ""}
                        </span>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ""
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          {webtoonSummaryData?.authors?.length ? (
            <Col>
              <Card className=" shadow m-4 view_cards">
                <CardBody>
                  <h3 className="fw-bolder dot_border">Authors</h3>
                  <Col>
                    {webtoonSummaryData.authors.map((author) => (
                      <ul>
                         {!isLinkFunctionalityActive ? 
                         <li key={author.id}>{author.name}</li> : currentAuthorId === author.id ?  <li key={author.id}>{author.name}</li> :  <li className="primary-text-color" style={{cursor: "pointer"}} onClick={()=>handleRedirectToViewAuthorPage(author.id)} key={author.id}>{author.name}</li> 
                        }
                      </ul>
                    ))}
                  </Col>
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}
          {webtoonSummaryData?.genres?.length ? (
            <Col lg="12">
              <Card className="me-2 shadow m-4 view_cards">
                <CardBody>
                  <h3 className="fw-bolder dot_border">Genre</h3>
                  <Col>
                    {webtoonSummaryData.genres.map((genre, index) => (
                      <ul>
                        <li key={index}>{genre.name}</li>
                      </ul>
                    ))}
                  </Col>
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}
        </Row>
        <Row>
          {webtoonSummaryData?.illustrators?.length ? (
            <Col lg="12">
              <Card className=" shadow m-4 view_cards">
                <CardBody>
                  <h3 className="fw-bolder dot_border">Illustrator</h3>
                  <Col>
                    {webtoonSummaryData.illustrators.map(
                      (illustrators, index) => (
                        <ul>
                          <li key={index}>{illustrators.name}</li>
                        </ul>
                      )
                    )}
                  </Col>
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}

          {webtoonSummaryData?.publics?.length ? (
            <Col lg="12">
              <Card className="me-2 shadow m-4 view_cards">
                <CardBody>
                  <h3 className="fw-bolder dot_border">Public</h3>
                  <Col>
                    {webtoonSummaryData.publics.map((publicsD, index) => (
                      <ul>
                        <li key={index}>{publicsD.name}</li>
                      </ul>
                    ))}
                  </Col>
                </CardBody>
              </Card>
            </Col>
          ) : (
            ""
          )}
        </Row>
      </Card>
    </Modal>
  );
}